export const GET_SYSTEM_STATUS = 'GET_SYSTEM_STATUS';
export const GET_SYSTEM_STATUS_SUCCESS = 'GET_SYSTEM_STATUS_SUCCESS';
export const GET_SYSTEM_STATUS_ERROR = 'GET_SYSTEM_STATUS_ERROR';
